import React from 'react'
import {ManageTemplatesDialog} from './template/ManageTemplatesDialog'
import {TemplateSelector} from './template/TemplateSelector'
import {withToggles} from 'startlibs/lib/hocs'
import {Fill} from 'react-slot-fill'
import {Header} from './Header'
import {Timer} from 'components/timer'
import {retryAutoSave, saveCompleteDocument} from 'report-components/lib/reducers'

@withToggles('manageTemplateDialog', 'isSavingNotification')
export class EditorHeader extends React.Component {

  render() {
    const {
      lastSaved,
      isSavingNotification,
      isRetryNotificationOpen,
      manageTemplateDialog,
      selectedTemplate,
      templates,
      dicomInfo,
      prepareTemplateToSave,
      availableSignatures,
      reportTitle,
      patientName,
      readOnly,
      studies,
      withoutSignatures,
      language,
      dateFormat,
      saveTemplate
    } = this.props
    return (
      <div className="report-builder-header">
        <Header.LeftContainer
          studies={studies}
          readOnly={readOnly}
          patientName={patientName}
        />
        <div className="right-container">
          <TemplateSelector
            withoutSignatures={withoutSignatures}
            templates={templates}
            selectedTemplate={selectedTemplate}
            dicomInfo={dicomInfo}
            saveTemplate={saveTemplate}
            reportTitle={reportTitle}
            availableSignatures={availableSignatures}
            prepareTemplateToSave={prepareTemplateToSave}
            openManageTemplatesDialog={manageTemplateDialog.open}
          />
          {
            manageTemplateDialog.isOpen &&
            <ManageTemplatesDialog
              templates={templates.available}
              closeDialog={manageTemplateDialog.close}
            />
          }
          <span className={'last-save-info' + (isSavingNotification.isOpen ? ' saving' : '')}>
            Report automatically saved <Timer language={language} dateFormat={dateFormat} time={lastSaved}/>
          </span>

          {
            isRetryNotificationOpen &&
            <Fill name="Notifications">
              <div className="system-notification failure">
                <div className="notification-message">
                  <div className="message-title">Report could not be automatically saved.</div>
                  <div className="message-description">Please check your internet connection and try again.</div>
                </div>
                <div className="buttons-container"><a className="button small-button alpha" onClick={retryAutoSave}>Try
                  again</a></div>
              </div>
            </Fill>
          }
        </div>
      </div>
    )
  }

  isSavingPromise = Promise.resolve()

  componentWillReceiveProps(newProps) {
    if (!this.props.isSaving && newProps.isSaving) {
      this.props.isSavingNotification.open()
      this.isSavingPromise = new Promise(resolve => setTimeout(resolve, 3000))
    } else if (this.props.isSaving && !newProps.isSaving) {
      this.isSavingPromise.then(this.props.isSavingNotification.close)
    }
    if (newProps.selectedTemplate !== this.props.selectedTemplate) {
      saveCompleteDocument()
    }
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/EditorHeader.jsx